import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import Signals from '../../../../../../../../../../../../../components/TableCell/components/Signals'
import Percent from '../../../../../../../../../../../../../components/TableCell/components/Percent'
import Entity from '../../../../../../../../../../../../../components/TableCell/components/Entity'
import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import InactivityIndicatorHeader from '../../../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Header'
import InactiveIndicatorCell from '../../../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Cell'
import { LOCALE_PREFIX } from '../../../../constants'
import hocConnect from './hocConnect'

import './style.scss'
import CellStyleWrapper from '../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'

@injectIntl
@hocConnect
export default class Table extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        filter: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        shareTableChange: PropTypes.func.isRequired,
        sorted: PropTypes.array,
    }

    static defaultProps = {
        isLoading: false,
    }

    onTableChange = (changeData) => {
        const { module, block, id, level, customData, shareTableChange } = this.props

        shareTableChange(module, block, id, level, customData, changeData)
    }

    renderSubComponent = (rowData) => {
        const { intl } = this.props

        return (
            <div className={'liens-share-table-subcomponent'}>
                <CellStyleWrapper isNotActive={rowData?.row?.original?.inactive}>
                    {`${intl.formatMessage({ id: `${LOCALE_PREFIX}.liens` })}: ${_.get(
                        rowData,
                        'row.original.description',
                        ''
                    )}`}
                </CellStyleWrapper>
            </div>
        )
    }

    render() {
        const { id, data, intl, pagination, sorted, isLoading, filter } = this.props

        if (_.isEmpty(data) && _.isEmpty(_.get(filter, 'activeFilters', {}))) return null

        return (
            <div className={'liens-share-table'}>
                <FilterTable
                    id={`liens-share-table-${id}`}
                    itemIdentifier={'id'}
                    data={data ?? []}
                    loading={isLoading}
                    columnsDefinition={[
                        {
                            // Needed for filter
                            // Has to match a key in filter.availableParameters
                            id: 'activity',
                            accessor: 'inactive',
                            Header: (val) => (
                                <div>
                                    {val.Controls}
                                    <InactivityIndicatorHeader />
                                </div>
                            ),
                            width: 35,
                            Cell: (value) => <InactiveIndicatorCell inactive={!!value?.value} />,
                            filterable: true,
                            filter: {
                                type: 'VALUE',
                                value: _.map(
                                    _.get(filter, 'availableParameters.activity.availableValues', []),
                                    (x) => ({
                                        value: _.get(x, 'value', null),
                                        item: _.get(x, 'title', null),
                                    })
                                ),
                            },
                        },
                        {
                            // Needed for filter
                            // Has to match a key in filter.availableParameters
                            id: 'subjectType',
                            accessor: 'type',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.lien` }),
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    {value?.value}
                                </CellStyleWrapper>
                            ),
                            filterable: true,
                            filter: {
                                type: 'VALUE',
                                value: _.map(
                                    _.get(filter, 'availableParameters.subjectType.availableValues', []),
                                    (x) => ({
                                        value: _.get(x, 'value', null),
                                        item: _.get(x, 'title', null),
                                    })
                                ),
                            },
                        },
                        {
                            accessor: 'sharePercentage',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.size` }),
                            width: 75,
                            sortable: true,
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <Percent value={_.get(value, 'value')} />
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'subject',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.subject` }),
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <Entity
                                        entity={_.get(value, 'value', null)}
                                        value={_.get(value, 'value.name')}
                                        type={_.get(value, 'value.type')}
                                        inactive={_.get(value, 'value.inactive')}
                                        entId={_.get(value, 'value.id', null)}
                                        rowInactive={_.get(value, 'original.inactive')}
                                    />
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'subject.indicators',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.signals` }),
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <Signals
                                        id={_.get(value, 'original.subject.id', null)}
                                        notice={_.get(value, 'value.notice', 0)}
                                        risk={_.get(value, 'value.risk', 0)}
                                        caution={_.get(value, 'value.caution', 0)}
                                    />
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'startDate',
                            sortable: true,
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.signed` }),
                            width: 120,
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <CustomDate date={_.get(value, 'value.value', null)} precision={'days'} />{' '}
                                </CellStyleWrapper>
                            ),
                        },
                    ]}
                    SubComponent={(rowData) => this.renderSubComponent(rowData)}
                    onTableChange={this.onTableChange}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                    expandOnRowClick
                />
            </div>
        )
    }
}
